/* global SideDrawer */

class CartDrawer extends SideDrawer {
  connectedCallback() {
    this.bindEvents();
  }

  bindEvents() {
    this.openDrawerViaEventHandler = this.handleDrawerOpenViaEvent.bind(this);
    this.closeDrawerViaEventHandler = this.close.bind(this, null);
    document.addEventListener('dispatch:cart-drawer:open', this.openDrawerViaEventHandler);
    document.addEventListener('dispatch:cart-drawer:close', this.closeDrawerViaEventHandler);
    document.addEventListener('dispatch:cart-drawer:refresh', this.cartRefreshHandler);
    this.addEventListener('on:cart-drawer:before-open', () => {
      theme.manuallyLoadImages(this);
      this.querySelectorAll('cc-cart-cross-sell').forEach((el) => el.init());
    });
    this.addEventListener('on:cart:after-merge', () => {
      theme.manuallyLoadImages(this);
      this.querySelectorAll('cc-cart-cross-sell').forEach((el) => el.init());
    });
  }

  disconnectedCallback() {
    document.removeEventListener('dispatch:cart-drawer:refresh', this.cartRefreshHandler);
    document.removeEventListener('dispatch:cart-drawer:open', this.openDrawerViaEventHandler);
    document.removeEventListener('dispatch:cart-drawer:close', this.closeDrawerViaEventHandler);
  }

  /**
   * Handle when the drawer is opened via an event
   * @param {object} evt - Event object.
   */
  handleDrawerOpenViaEvent(evt) {
    this.open(evt.detail ? evt.detail.opener : null);
  }

  /**
   * Trigger refresh of contents
   */
  cartRefreshHandler() {
    this.querySelector('cart-form').refresh();
  }

  /**
   * Update section's cart-form element with new contents
   * @param {string} html - Whole-section HTML.
   */
  updateFromCartChange(html) {
    this.querySelector('cart-form').refreshFromHtml(html);
  }
}

window.customElements.define('cart-drawer', CartDrawer);

// IDs of the two specific products that must be in the cart to qualify for the free gift
var requiredProductVariantIds = [42575962374322, 42201293553842]; // Replace with the variant IDs of X and Y products
var freeGiftVariantId = 43502532657330; // Replace with the free gift's variant ID

// Function to check the cart and add a free gift if both required products are in the cart
function addFreeGiftIfBothProductsInCart() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      let requiredProductsInCart = 0;
      let freeGiftInCart = false;

      // Check if both required products and the free gift are in the cart
      cart.items.forEach(item => {
        if (requiredProductVariantIds.includes(item.id)) {
          requiredProductsInCart++;
        }
        if (item.id === freeGiftVariantId) {
          freeGiftInCart = true;
        }
      });

      // If both required products are in the cart and the free gift isn't, add the free gift
      if (requiredProductsInCart === requiredProductVariantIds.length && !freeGiftInCart) {
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: freeGiftVariantId,
            quantity: 1
          })
        }).then(() => {
          // Optionally, refresh the cart drawer to show the updated contents
          document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', {
            bubbles: true
          }));
        });
      }
    });
}

// Listen for when a product is added to the cart
document.addEventListener('on:cart:add', (event) => {
  // Check if both required products are in the cart, and add the free gift
  addFreeGiftIfBothProductsInCart();
});
